/* eslint-disable import/prefer-default-export */
import qs from 'query-string';
import { useEffect, useState } from 'react';

export const useQuery = () => {
  const search = globalThis.location?.search || '';
  const [query, setQuery] = useState(qs.parse(search));

  useEffect(() => {
    setQuery(qs.parse(search));
  }, [search]);

  return query;
};
